// App.js
import React from "react";
import ParallaxContainer from "./ParallaxContainer";

function App() {
	return (
		<div className="App">
			<ParallaxContainer />
		</div>
	);
}

export default App;
